@if (searchForm) {
    @if (templateId$ | async; as templateId) {
        <div class="aimo-order-template-details">
            <aimo-order-template-details [orderTemplateId]="templateId"></aimo-order-template-details>
        </div>
    } @else {
        @let isMobileApp = isMobileApp$|async;
        @if (!isMobileApp && breadcrumbs$ | async; as breadcrumbs) {
            <aimo-breadcrumb
                [hideTitle]="true"
                [showBackLink]="false"
                [addFrontPageLink]="false"
                [normalBreadCrumbs]="breadcrumbs">
            </aimo-breadcrumb>
        }
        <cx-page-slot position="TopContent"></cx-page-slot>
        @if (cartList$ | async; as templates) {
            <cx-page-slot position="PageDescription"></cx-page-slot>
            <div class="templates-search" [formGroup]="searchForm">
                @if (customerAdmin) {
                    <div class="form-check">
                        <label>
                            <input
                                type="checkbox"
                                (change)="setHideNormalOrderTemplatesFromBasicUsers()"
                                [formControlName]="'hideNormalOrderTemplatesFromBasicUsers'"/>
                            <span>{{
                                    'aimo.ordertemplates.isHideNormalOrderTemplatesFromBasicUsers' | cxTranslate
                                }}</span>
                        </label>
                        <br/>
                    </div>
                }
                <div class="row no-gutters align-items-center">
                    <div
                        class="cx-search-criteria-find"
                        [ngClass]="
                            publicTemplatesVisible()
                                ? 'col-12 col-lg-4 mr-lg-3 order-lg-1 order-2 pb-3 pb-lg-0'
                                : 'col-12 col-lg-4 pb-3 pb-lg-0'
                        ">
                        <aimo-cx-input
                            [inputClass]="'input-md mt-0'"
                            (input)="search()"
                            [placeholder]="'aimo.ordertemplates.search'"
                            [parentForm]="searchForm"
                            [nameForm]="'search'"
                            [inputIcon]="'icon-magnifying-glass icon-petrol-blue'">
                        </aimo-cx-input>
                    </div>
                    <div
                        [ngClass]="
                            publicTemplatesVisible()
                                ? 'col-12 col-lg-auto ml-lg-auto order-lg-2 order-3 pb-3 pb-lg-0'
                                : 'col-12 col-lg-8'
                        ">
                        <div class="aimo-sorting d-flex justify-content-end align-items-center">
                            <ng-select
                                [id]="'sortField'"
                                [bindLabel]="'code'"
                                [bindValue]="'code'"
                                [clearable]="false"
                                [closeOnSelect]="true"
                                [formControlName]="'sortField'"
                                [items]="sortEntries"
                                [multiple]="false"
                                [searchable]="false"
                                (change)="fetchTemplates()"
                                class="text-left nowrap">
                                <ng-template ng-option-tmp let-item="item">
                                    {{ 'aimo.baseorder.sort.' + item.code | cxTranslate }}
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                    {{ 'aimo.baseorder.sort.' + item.code | cxTranslate }}
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    @if (publicTemplatesVisible()) {
                        <div class="col-12 col-lg-auto ml-lg-3 order-lg-3 order-1 pb-3 pb-lg-0">
                            <button
                                class="btn btn-sm btn-primary"
                                (click)="openCreateTemplateModal(); pushGtmEvent('ordertemplates-create-new')">
                                <i class="icon-plus-circle icon-white icon-inline aimo-icon mr-2 mb-1"></i>
                                {{ 'aimo.ordertemplates.button.create' | cxTranslate }}
                            </button>
                        </div>
                    }
                    @if (publicTemplatesVisible()) {
                        <div class="col-12 col-lg-8 order-4 pt-lg-3">
                            @if (templates.facets?.length > 1) {
                                <div class="facet-wrapper fade-white">
                                    <div class="facets">
                                        @for (facet of templates.facets; track facet.code) {
                                            <div class="aimo-facet">
                                                <button
                                                    class="heading btn-facet btn-sm"
                                                    [ngClass]="
                                                        selectedFacet?.code === facet.code
                                                            ? { selected: true }
                                                            : { selected: false }
                                                    "
                                                    (click)="toggleFacet(facet); pushGtmEvent('ordertemplates-facets')">
                                                    {{ 'aimo.ordertemplates.privacy.' + facet.code | cxTranslate }}
                                                    <span class="amount">{{ getFacetHits(facet) }}</span>
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
            <div class="aimo-order-templates-table">
                @for (template of templates.carts; track template.code) {
                    <aimo-order-template-row [orderTemplate]="template"></aimo-order-template-row>
                }
            </div>
        }

        <cx-page-slot position="BottomContent"></cx-page-slot>
    }
}
